import { useNotificationsContext } from "common/context/NotificationsProvider"
import { NotificationsService } from "common/services/NotificationsService"
import showToast from "common/utils/notification"
import { nanoid } from "nanoid"
import { Button } from "primereact/button"
import { Checkbox } from "primereact/checkbox"
import { InputSwitch } from "primereact/inputswitch"
import { useEffect, useState } from "react"

import { getUsuarioEmpresas } from "api/Usuario.service"
import { useTranslation } from "react-i18next"
import "../style.scss"

const NotificationsFilter = () => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'allNotifications' does not exist on type...
  const { allNotifications, setNotificationsQueryState } =
    useNotificationsContext()
  const { queryState } = allNotifications
  const [options, setOptions] = useState({
    types: [],
    categories: [],
    empresas: [],
  })

  const getEmpresaRazónSocial = (empresaId: $TSMigrationFixMe) =>
    // @ts-expect-error TS(2339): Property 'razonSocial' does not exist on type 'nev...
    options.empresas?.find(({ id }) => empresaId === id)?.razonSocial

  const notificationsFilterSections = [
    {
      title: `${t("notifications.filter.titleType")}`,
      key: "Types",
      list: options.types,
    },
    {
      title: `${t("notifications.filter.titleCompany")}`,
      key: "SubTypes",
      list: options.empresas?.map(({ id }) => id) || [],
    },
    {
      title: `${t("notifications.filter.titleCategory")}`,
      key: "Categories",
      list: options.categories,
    },
  ]

  const handleChangeTypesCategoriesParam = (
    event: $TSMigrationFixMe,
    key: $TSMigrationFixMe
  ) => {
    const selecteds = [...queryState[key]]

    if (event.checked) {
      selecteds.push(event.value)
    } else {
      selecteds.splice(selecteds.indexOf(event.value), 1)
    }

    setNotificationsQueryState({
      ...queryState,
      skipCount: 0,
      [key]: selecteds,
    })
  }

  const handleChangeReadParam = (event: $TSMigrationFixMe) => {
    setNotificationsQueryState({
      ...queryState,
      skipCount: 0,
      onlyNotRead: event.value,
    })
  }

  const resetFilter = () => {
    setNotificationsQueryState()
  }

  useEffect(() => {
    Promise.all([
      NotificationsService.getNotificationsTypes(),
      NotificationsService.getNotificationsCategories(),
      getUsuarioEmpresas({ Verificada: true }),
    ])
      .then((response) => {
        const [types, Categories, empresas] = response
        setOptions({
          types: types.data.items,
          categories: Categories.data.items,
          empresas: empresas?.items as [],
        })
      })
      .catch(showToast.errorServidor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='notifications-filter w-25'>
      <div className='p-4 notifications-filter-container'>
        <div className='flex-row pb-3 d-flex justify-content-between'>
          <div className='my-auto notifications-filter-titles'>
            {t("notifications.filter.title")}
          </div>
          <Button
            className='p-0 p-button-text notifications-actions'
            onClick={resetFilter}
          >
            {t("notifications.filter.clearFilterButton")}
          </Button>
        </div>
        <div className='flex-row pb-3 d-flex justify-content-between'>
          <div className='my-auto'>
            {t("notifications.filter.onlyNoReadButton")}
          </div>
          <InputSwitch
            checked={queryState.onlyNotRead}
            onChange={handleChangeReadParam}
          />
        </div>
        {notificationsFilterSections.map(({ title, key, list }) => (
          <div
            key={nanoid()}
            className='pb-3 text-left d-flex flex-column'
          >
            <div className='mb-3 notifications-filter-titles'>{title}</div>
            <div className='notifications-filter-list'>
              {list.map((option) => (
                <div
                  key={nanoid()}
                  className='mb-2 d-flex'
                >
                  <Checkbox
                    inputId={option}
                    value={option}
                    checked={queryState[key].includes(option)}
                    onChange={(event) =>
                      handleChangeTypesCategoriesParam(event, key)
                    }
                  />
                  <label
                    htmlFor={option}
                    className='my-auto ml-2 p-checkbox-label'
                  >
                    {title === "Empresa"
                      ? getEmpresaRazónSocial(option)
                      : option}
                  </label>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default NotificationsFilter
